import { getCurrentClinic } from '@/utils/localStorageManager'

/**
 * Unidades do GRUPO da clínica ativa (matriz + filiais do mesmo
 * `root_clinic_id`), no formato do seletor.
 *
 * É o único getter de unidade em uso. Os antigos `unities` e
 * `unitySelectOptions` foram removidos na spec v3 (impl-01 §3.4): ambos
 * filtravam por `root_clinic_id` truthy — ou seja, listavam só as FILIAIS,
 * deixando a matriz de fora — e nenhum tinha consumidor. `unities` ainda era
 * curried (`state => () => ...`), o que o tornava inutilizável como getter.
 */
const unitiesSelectOptions = state => {
  const clinic = getCurrentClinic()
  const rootClinicId = clinic.root_clinic_id || clinic.id
  return state.clinics
    .filter(
      unity =>
        unity.id === rootClinicId || unity.root_clinic_id === rootClinicId
    )
    .map(unity => ({
      value: unity.id,
      text: unity.name
    }))
}

export default {
  unitiesSelectOptions
}
